/* unplugin-vue-components disabled */import script from "./additional-resources.vue?vue&type=script&lang=js"
export * from "./additional-resources.vue?vue&type=script&lang=js"

import "./additional-resources.vue?vue&type=style&index=0&id=24e66fa5&lang=scss"

const __exports__ = script;

export default __exports__